import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";
import { RoadState } from "./states/road/RoadState";
import { SponsorManager, WhyCallAd } from "./SponsorManager";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            GameManager.initGameDistributionSDK();
        }

        GameManager.game = game;

        GameVars.noBloodMode = false;

        GameVars.randomDataGenerator = new Phaser.RandomDataGenerator([GameManager.game.time.time.toString()]);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_NONE) {
            if (top.location.href.indexOf("footchinko.com") > -1 || top.location.href.indexOf("127") > -1 || top.location.href.indexOf("ravalmatic.com") > -1 || top.location.href.indexOf("localhost") > -1 || top.location.href.indexOf("192.168") > -1) {
                GameManager.readGameData();
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_MINIJUEGOS) {

            if (window.location.href.indexOf("mini") > -1 ||
                top.location.href.indexOf("mini") > -1 ||
                window.location.href.indexOf("footchinko") > -1 ||
                window.location.href.indexOf("localhost") > -1 ||
                window.location.href.indexOf("192") > -1
            ) {
                GameManager.readGameData();
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            if (window.location.href.indexOf("lagged") > -1 ||
                top.location.href.indexOf("lagged") > -1 ||
                window.location.href.indexOf("footchinko") > -1 ||
                window.location.href.indexOf("localhost") > -1 ||
                window.location.href.indexOf("192") > -1
            ) {
                GameManager.readGameData();
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIND) {
            GameManager.readGameData();
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEZOP) {
            GameManager.readGameData();
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {
            GameManager.readGameData();
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_YANDEX) {
            
            SponsorManager.adFilter(() => {
                GameManager.readGameData();
            }, GameManager.game, WhyCallAd.onGameStart);

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {

            GameVars.noBloodMode = !showBlood;
            
            const domains = ["funo.com", "yurk.com", "friv.com", "femo.com", "fabo.com", "friv.co.uk", "friv4school.com", "frivmath.com", "funomath.com", "localhost", "127", "192", "footchinko.com"];
                
            if (GameVars.areValidDomains(domains)) {
                GameManager.readGameData();
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            GameManager.readGameData();
        }
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "f98a506d65e845d28f6e400b55e49af2",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        AudioManager.unmute();
                        break;
                    case "SDK_GAME_PAUSE":
                        AudioManager.mute(); 
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {

                    GameVars.gameData = {
                        muted: false,
                        stats: {
                            highscore: 0,
                            crosses: 0,
                            deaths: 0,
                            closeCalls: 0,
                            streak: 0,
                            feathers: 0,
                            drowned: 0
                        },
                        dPadPosition: "left",
                        desktopTutorialSeen: false
                    };
                }

                if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

                    const laggedAchievementStr = localStorage.getItem(GameConstants.LAGGED_ACHIEVEMENTS_DATA_KEY);

                    if (laggedAchievementStr) {
                        GameVars.laggedAchievements = JSON.parse(laggedAchievementStr);
                    } else {
                        GameVars.laggedAchievements = [0, 0, 0, 0, 0, 0, 0, 0, 0];
                    }
                }

                GameManager.startGame();
            },
            function (error: Error): void {
                GameManager.log("error retriving saved game data.", error);
            }
        );
    }

    public static onGameAssetsLoaded(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            LaggedAPI.init("goo_chickengo_vintgs", "lagdevaF3001");
        }

        AudioManager.init(GameManager.game);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

            GamePix.game.gameLoaded(function (): void {
                GameManager.enterSplashScene();
            });
        } else {
            GameManager.enterSplashScene();
            // GameManager.enterRoadScene();
            // GameManager.enterDevelopmentState();
        }
    }

    public static enterSplashScene(): void {

        GameManager.game.state.start("SplashState", true, false);
    }

    public static enterRoadScene(): void {

        GameManager.game.state.start("RoadState", true, false);
    }

    public static onDesktopTutorialSeen(): void {

        GameVars.gameData.desktopTutorialSeen = true;

        GameManager.writeGameData();
    }

    public static enterInstructionsScene(): void {

        GameManager.game.state.start("InstructionsState", true, false);
    }

    public static enterStatsScene(): void {

        GameManager.game.state.start("StatsState", true, false);
    }

    public static enterDevelopmentState(): void {

        GameManager.game.state.start("DevelopmentState", true, false);
    }

    public static showPauseLayer(): void {

        RoadState.currentInstance.showPauseLayer();
        GameVars.paused = true;
    }

    public static hidePauseLayer(): void {

        RoadState.currentInstance.hidePauseLayer();
        GameVars.paused = false;
    }

    public static switchdPad(): void {

        RoadState.currentInstance.switchdPad();
    }

    public static setDPad(pos: string): void {

        GameVars.gameData.dPadPosition = pos;
        GameManager.writeGameData();
    }

    public static switchSound(): void {

        if (GameVars.gameData.muted) {
            AudioManager.unmute();
        } else {
            AudioManager.mute();
        }
    }

    public static resetStats(): void {

        const stats: Stats = {
            highscore: 0,
            crosses: 0,
            deaths: 0,
            closeCalls: 0,
            streak: 0,
            feathers: 0,
            drowned: 0
        };

        GameVars.gameData.stats = stats;
        GameManager.writeGameData();

        GameManager.enterStatsScene();
    }

    public static reset(): void {

        GameManager.enterRoadScene();
    }

    public static computeAchievements(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_MINIJUEGOS) {

            miniplaySend2API("last", GameVars.savedChicken);
            miniplaySend2API("crossed", GameVars.savedChicken);
            miniplaySend2API("killed", GameVars.deaths);
            miniplaySend2API("drowned", GameVars.drowned);
            miniplaySend2API("feathers", GameVars.feathers);

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            const api_awards: any = [];

            if (GameVars.savedChicken >= 15 && GameVars.laggedAchievements[0] === 0) {
                GameVars.laggedAchievements[0] = 1;
                api_awards.push("gochicky_gogm_avkka001");
            }

            if (GameVars.savedChicken >= 20 && GameVars.laggedAchievements[1] === 0) {
                GameVars.laggedAchievements[1] = 1;
                api_awards.push("gochicky_gogm_avkka002");
            }

            if (GameVars.gameData.stats.deaths >= 200 && GameVars.laggedAchievements[5] === 0) {
                GameVars.laggedAchievements[5] = 1;
                api_awards.push("gochicky_gogm_avkka006");
            }

            if (GameVars.gameData.stats.deaths >= 300 && GameVars.laggedAchievements[6] === 0) {
                GameVars.laggedAchievements[6] = 1;
                api_awards.push("gochicky_gogm_avkka007");
            }

            if (GameVars.gameData.stats.drowned >= 150 && GameVars.laggedAchievements[7] === 0) {
                GameVars.laggedAchievements[7] = 1;
                api_awards.push("gochicky_gogm_avkka008");
            }

            if (GameVars.gameData.stats.feathers >= 150 && GameVars.laggedAchievements[8] === 0) {
                GameVars.laggedAchievements[8] = 1;
                api_awards.push("gochicky_gogm_avkka009");
            }

            if (api_awards.length > 0) {

                localStorage.setItem(GameConstants.LAGGED_ACHIEVEMENTS_DATA_KEY, JSON.stringify(GameVars.laggedAchievements));

                LaggedAPI.Achievements.save(api_awards, function (response: any) {
                    if (response.success) {
                        console.log("achievement saved");
                    } else {
                        console.log(response.errormsg);
                    }
                });
            }
        }
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            },
            function (error: Error): void {
                GameManager.log("error saving game data", error);
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static startGame(): void {

        GameManager.game.state.start("PreLoader", true, false);
    }

    private static getGameStorageData(key: string, successCb: Function, failureCb: Function): void {

        let data: string;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {
            data = GamePix.localStorage.getItem(key);
        } else {
            data = localStorage.getItem(key);
        }

        successCb(data);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function, failureCb: Function): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {
            GamePix.localStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
}
